$(document).ready(function () {
  $('.generalmessage').prependTo('header');

  createBurgerIcon();
  customSearchBar();
  customAnimation();

  //sponsors heading replacement
  $(window).load(function () {
    const sponsorsTitle = $('.homepageh1').text();
    $('.homepageh1').replaceWith(`<h2 class="homepageh1">${sponsorsTitle}</h2>`);
  });
});

// --------------------------------
// Helpers
// Custom burger menu
function createBurgerIcon() {
  $.each(new Array(3), function () {
    $('.header .mobile-nav-toggle').append('<div></div>');
  });
}

// -------------------------------
// Searchbox scripts
function customSearchBar() {
  let searchPlaceholder = 'Search Website';

  $('.header .searchBox input').val('');
  $('.header .searchBox input').attr('placeholder', searchPlaceholder);

  $('.mobile-menu-container .search-container input').val('');
  $('.mobile-menu-container .search-container input').attr('placeholder', searchPlaceholder);
}

// -------------------------------
// custom animation for menu
function customAnimation() {
  $('.groups .group').each(function () {
    let nmbrSlides = 1;
    $(this)
      .find('.items > .item')
      .each(function () {
        let nmbrSubSlides = 1;
        $(this).addClass(`dropdown_menu-${nmbrSlides}`);
        $(this).find('.navClonedItem').remove();
        nmbrSlides++;
        $('.navDummyLink').remove();
        $('.navClonedItem ').remove();

        $(this)
          .find('.subitems > .item')
          .each(function () {
            $(this).addClass(`dropdown_submenu-${nmbrSubSlides}`);
            $(this).find('.navClonedItem').remove();
            nmbrSubSlides++;
          });
      });
  });
}
